import BoundaryFactory from './boundary-factory';
import Branch from "./branch-boundary";
import Cuboid from "./cuboid-boundary";
import Group from "./group-boundary";
import Model from "./model-boundary"
import Universe from "./universe-boundary";
import Volume from "./volume-boundary";

BoundaryFactory.register("Branch", Branch);
BoundaryFactory.register("Cube", Cuboid);
BoundaryFactory.register("Group", Group);
BoundaryFactory.register("Model", Model);
BoundaryFactory.register("Universe", Universe);
BoundaryFactory.register("Volume", Volume);
